import React from 'react';
import FinsightBookDemo from '@/finsight/ui/components/staticPages/common/FinsightBookDemo';
import ComparePlansTable from './ComparePlansTable';

import styles from '../styles.scss';

const ComparePlansPanel = () => (
  <div className={ styles.pricingPanelContainer }>
    <div className={ styles.pricingHeader }>
      <div className={ styles.pricingHeaderTitle }>
        Compare Plans
      </div>
      <div className={ styles.pricingHeaderDescription }>
        Access the cleanest, most comprehensive, and most accurate market dataset in the industry.<br />
        Choose the best plan to suit your needs or speak to a member of our team to find the best fit.
      </div>
    </div>

    <ComparePlansTable />

    <FinsightBookDemo />
  </div>
);

export default ComparePlansPanel;
